import { Currency, Money } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
export function sumAmounts(amounts) {
  if (amounts.length > 0) {
    const summedAmount = amounts.reduce((sum, balance) => sum + (balance.amount ?? 0), 0);
    const currency = amounts[0].currency ?? Currency.USD;
    return Money.create({
      amount: summedAmount,
      currency
    });
  }
  return Money.create({
    amount: 0,
    currency: Currency.USD
  });
}